import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { customElement as e } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/custom-element.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { CarouselBase } from '../../lit-mixins/carousel-base/index.js';
import { getGenericCarouselSettings } from '../../molecules/generic-carousel/utils/settings.js';
import '../../atoms/buttons/enums.js';
import { setDataAttributes, isRTL } from '../../utilities/dom-helpers/index.js';
import { setLineClamp } from '../../../generated/global-content/components/utilities/text-helpers/index.js';
import { BaseWithUtils } from '../../lit-mixins/base-with-utils/index.js';
import { renderLayout } from './layout/index.js';
import css_248z$1 from './product-preview.scss.js';
import css_248z$2 from '../../atoms/buttons/generic-button/styles/secondary-button.scss.js';
import css_248z from '../../molecules/generic-carousel/generic-carousel.scss.js';

const LitElementWithUtils = BaseWithUtils(s);
const headlineCharLimit = 120;
let ProductPreview = class ProductPreview extends CarouselBase(LitElementWithUtils) {
    constructor() {
        super(...arguments);
        this.divider = false;
        this.query = '(max-width: 767px)';
        this.navTemplate = '';
        this.isMobile = false;
        this.headingSlot = null;
    }
    handleMediaQuery(event) {
        this.isMobile = event.detail.value;
    }
    firstUpdated() {
        setTimeout(() => {
            this.transformSlotsIntoSlides();
            this.initCarousel(getGenericCarouselSettings);
            setDataAttributes(this, 'headline', null);
            setLineClamp(this, headlineCharLimit, null);
        }, 0);
    }
    render() {
        var _a;
        return this.renderCarousel(x `<div class="generic-carousel-container ${this.rtl || isRTL() ? 'rtl' : ''} ${this.divider ? 'divider' : ''} ${(_a = this.utilityClasses) !== null && _a !== void 0 ? _a : ''}">${renderLayout(this)}<carousel-navigation ?rtl="${this.rtl || isRTL() ? 'rtl' : ''}" nextText="${this.nextText}" previousText="${this.previousText}"></carousel-navigation></div>`);
    }
};
ProductPreview.styles = [
    LitElementWithUtils.styles || [],
    css_248z,
    css_248z$1,
    css_248z$2,
];
__decorate([
    n({ type: Boolean })
], ProductPreview.prototype, "divider", void 0);
__decorate([
    t()
], ProductPreview.prototype, "query", void 0);
__decorate([
    n({ type: String })
], ProductPreview.prototype, "navTemplate", void 0);
__decorate([
    t()
], ProductPreview.prototype, "isMobile", void 0);
__decorate([
    t()
], ProductPreview.prototype, "headingSlot", void 0);
ProductPreview = __decorate([
    e('product-preview')
], ProductPreview);

export { ProductPreview };
